export default [
  {
    id: 'CASH',
    name: 'Gotówka'
  },
  {
    id: 'TRANSFER',
    name: 'Przelew'
  },
  {
    id: 'CARD',
    name: 'Karta'
  }
];
